export enum MapDataType {
    FIELDS = "FIELDS",
    IRRITILES = "IRRITILES",
    IRRITILE = "IRRITILE",
}
